import * as th from 'tree-helper'

function isJSON(jsonString) {
    try {
        var o = JSON.parse(jsonString);
  
        // Handle non-exception-throwing cases:
        // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
        // but... JSON.parse(null) returns null, and typeof null === "object", 
        // so we must check for that, too. Thankfully, null is falsey, so this suffices:
        if (o && typeof o === "object") {
            return true
        }
    }
    catch (e) {
        return false
     }
    return false
}

function JSONParse(jsonString) {
    if(isJSON(jsonString)) return JSON.parse(jsonString)
    else return {}
}

function ArrayParse(jsonString) {
    if(isJSON(jsonString)) return JSON.parse(jsonString)
    else return []
}

function stringToArray(string){
    let new_array = []

    if(typeof(string)=='string') 
        { new_array = string.split(',')
          for(let i=0; i<new_array.length; i++)
          {
              new_array[i] = new_array[i].replace(/^\s+|\s+$/g,"")
          }
          return new_array
        }
    else return false

}

function arrayToString(array){
    if(Array.isArray(array)) {
        return array.toString(array)
    }
    else return false
}

function deepCopy(obj) {
    if (obj === null || typeof(obj) !== 'object')
    return obj;
  
    var copy = obj.constructor();
  
    for (var attr in obj) {
      if (obj[attr]) {
        copy[attr] = deepCopy(obj[attr])
      }
    }
  
    return copy
}

function stringToDate(string) {
    //"2019-11-13" 형식의 데이터를 Javascript Date로 변환하여 반환

    let new_date = new Date(string)
    new_date.setHours(0)
    new_date.setMinutes(0)
    new_date.setSeconds(0)
    
    return new_date 
}

function dateToString(date) {
    //날짜를 "2019-11-13"로 변환하여 반환
    
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

function getTimeStamp() {

    let d = new Date();

    let s =
        leadingZeros(d.getFullYear(), 4) + '-' +
        leadingZeros(d.getMonth() + 1, 2) + '-' +
        leadingZeros(d.getDate(), 2);

    return s;
}

function leadingZeros(n, digits) {

    var zero = '';
    n = n.toString();

    if (n.length < digits) {
        for (let i = 0; i < digits - n.length; i++)
            zero += '0';
    }

    return zero + n;
}

function completeTree(data){
    const completedData = {
        children: []
    }

    th.breadthFirstSearch(data, (node, parent) => {
        for (let key in completedData) {
            if (!node[key]) {
              node[key]=completedData[key]
            }
        }
        if(parent != null) {
            node.parent = parent
        }
        else{
            node.parent = null
        }    
    })
}

function thousandSeprator(amount) {
    if (typeof amount !== 'undefined' && amount !== null && amount !== 0 && amount !== '' && amount !== '0') {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
        return amount;
    }
}

function thousandSepratorRemover (amount) {
    if (typeof amount !== 'undefined' && amount !== null && amount !== 0 && amount !== '') {
        if (amount.match(/,(?=\d{3})/g)) {
            let removed = amount.replace(/,(?=\d{3})/g, '')
            return Number(removed)
        } else {
            if (!Number(amount)) {
                return amount
            } else {
                return Number(amount)   
            }
        }
    } else {
        return amount;
    }
    
}

function validateEmail(email){
    var emailReg = /^([0-9a-zA-Z_\\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
    return emailReg.test(email);
}

// 저장 요청에 싣는 회사명. 협력사 화면은 URL(cmp/cpn)로 복원된 평가(store campaign_in_progress)의 회사명을 쓴다
// — 주소창의 회사명(cpnm)은 고쳐 쓸 수 있어 믿지 않는다. 다른 평가를 보고 있으면(관리자 답변 보기 등) 기존대로 cpnm, 없으면 문항 응답의 회사명.
function resolveSaveCompanyName(campaign_in_progress, query, fallback) {
    const c = campaign_in_progress || {}
    if (c.company_name && String(c.campaign_id) === String(query.cmp) && String(c.request_company_id) === String(query.cpn)) {
        return c.company_name
    }
    return query.cpnm ?? fallback
}

export {
    isJSON,
    JSONParse,
    ArrayParse,
    stringToArray,
    arrayToString,
    deepCopy,
    stringToDate,
    dateToString,
    getTimeStamp,
    completeTree,
    thousandSeprator,
    thousandSepratorRemover,
    validateEmail,
    resolveSaveCompanyName
}